import React, { useContext, useEffect } from 'react'
import { always, pathOr, tryCatch } from 'ramda'
import pclnExperimentation from '@pcln/experimentation'
import { BootstrapDataContext } from '../contexts'
import KaleyAdBox from '../components/promos/express-promo/KaleyAdBox'
import KaleyPromoAdBox from '../components/promos/express-promo/KaleyPromoAdBox'

const IncredibleTileExperiment = () => {
  const { aceContent, seti: { MKTG_HOMEPAGE_SALE_BOX = 'DEFAULT' } = {} } = useContext(BootstrapDataContext)
  const adBoxStringValues = pathOr(
    '{}',
    [ 'contentValues', 'HOMEPAGE', 'SITE-X.HOMEPAGE.PROMOTIONSBANNER.KALEYPROMOADBOX', 'value' ],
    aceContent
  )
  const adBoxValues = tryCatch(JSON.parse, always({}))(adBoxStringValues)

  useEffect(() => {
    pclnExperimentation.fireImpression('MKTG_HOMEPAGE_SALE_BOX')
  }, [])

  if (Object.keys(adBoxValues).length === 0 || MKTG_HOMEPAGE_SALE_BOX === 'DEFAULT') {
    return <KaleyAdBox />
  }
  return <KaleyPromoAdBox adBoxValues={adBoxValues} />
}

export default IncredibleTileExperiment
